import { render, staticRenderFns } from "./role-auth.vue?vue&type=template&id=5ed3186b&scoped=true&"
import script from "./role-auth.vue?vue&type=script&lang=js&"
export * from "./role-auth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed3186b",
  null
  
)

export default component.exports